function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "249px",
    height: "272px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#65c1c7",
    d: "M 156.5,22.5 C 156.5,25.5 156.5,28.5 156.5,31.5C 147.167,31.5 137.833,31.5 128.5,31.5C 128.5,84.5 128.5,137.5 128.5,190.5C 126.583,205.92 117.917,215.086 102.5,218C 88.8217,220.175 78.155,215.675 70.5,204.5C 85.2344,211.193 98.4011,208.86 110,197.5C 112.777,194.282 114.777,190.615 116,186.5C 117.483,131.879 117.983,77.2127 117.5,22.5C 130.5,22.5 143.5,22.5 156.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6eb1b6",
    d: "M 156.5,22.5 C 157.477,25.2869 157.81,28.2869 157.5,31.5C 157.5,31.8333 157.5,32.1667 157.5,32.5C 148.167,32.5 138.833,32.5 129.5,32.5C 129.832,85.336 129.499,138.003 128.5,190.5C 128.5,137.5 128.5,84.5 128.5,31.5C 137.833,31.5 147.167,31.5 156.5,31.5C 156.5,28.5 156.5,25.5 156.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.376
    },
    fill: "#770e29",
    d: "M 157.5,32.5 C 157.5,32.1667 157.5,31.8333 157.5,31.5C 161.167,31.5 164.833,31.5 168.5,31.5C 168.5,34.1667 168.5,36.8333 168.5,39.5C 167.532,37.3926 167.198,35.0593 167.5,32.5C 164.167,32.5 160.833,32.5 157.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 157.5,32.5 C 160.538,47.1645 168.205,58.4978 180.5,66.5C 181.5,66.8333 182.167,67.5 182.5,68.5C 189.635,77.409 198.969,82.7423 210.5,84.5C 210.5,94.5 210.5,104.5 210.5,114.5C 191.614,114.759 174.28,109.759 158.5,99.5C 158.217,98.7109 157.717,98.0442 157,97.5C 156.5,124.831 156.333,152.165 156.5,179.5C 153.173,211.992 136.173,233.825 105.5,245C 87.6033,249.383 70.27,247.883 53.5,240.5C 51.8525,238.674 49.8525,237.34 47.5,236.5C 46.5084,236.672 45.8417,236.338 45.5,235.5C 27.0561,213.712 21.8895,189.045 30,161.5C 41.4945,134.177 61.9945,118.844 91.5,115.5C 92.5,115.5 93.5,115.5 94.5,115.5C 94.5,125.167 94.5,134.833 94.5,144.5C 77.5956,141.037 64.7622,146.704 56,161.5C 50.1466,177.203 53.3132,190.703 65.5,202C 67.0779,203.094 68.7446,203.928 70.5,204.5C 78.155,215.675 88.8217,220.175 102.5,218C 117.917,215.086 126.583,205.92 128.5,190.5C 129.499,138.003 129.832,85.336 129.5,32.5C 138.833,32.5 148.167,32.5 157.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#e02250",
    d: "M 157.5,32.5 C 160.833,32.5 164.167,32.5 167.5,32.5C 167.198,35.0593 167.532,37.3926 168.5,39.5C 170.19,49.5855 174.19,58.5855 180.5,66.5C 168.205,58.4978 160.538,47.1645 157.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#65b7bd",
    d: "M 182.5,68.5 C 191.179,73.3921 200.512,76.0588 210.5,76.5C 210.5,79.1667 210.5,81.8333 210.5,84.5C 198.969,82.7423 189.635,77.409 182.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#e71e50",
    d: "M 210.5,84.5 C 211.833,84.8333 213.167,85.1667 214.5,85.5C 216.607,86.4682 218.941,86.8016 221.5,86.5C 221.5,98.8333 221.5,111.167 221.5,123.5C 218.5,123.5 215.5,123.5 212.5,123.5C 196.758,122.254 182.424,117.254 169.5,108.5C 169.217,107.711 168.717,107.044 168,106.5C 167.5,134.831 167.333,163.165 167.5,191.5C 162.143,229.357 140.476,251.191 102.5,257C 83.6908,258.305 67.0242,253.138 52.5,241.5C 52.5,240.833 52.8333,240.5 53.5,240.5C 70.27,247.883 87.6033,249.383 105.5,245C 136.173,233.825 153.173,211.992 156.5,179.5C 157.167,152.833 157.833,126.167 158.5,99.5C 174.28,109.759 191.614,114.759 210.5,114.5C 210.5,104.5 210.5,94.5 210.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#4b0919",
    d: "M 214.5,85.5 C 217.167,85.5 219.833,85.5 222.5,85.5C 222.5,98.5 222.5,111.5 222.5,124.5C 218.958,124.813 215.625,124.479 212.5,123.5C 215.5,123.5 218.5,123.5 221.5,123.5C 221.5,111.167 221.5,98.8333 221.5,86.5C 218.941,86.8016 216.607,86.4682 214.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5506d",
    d: "M 158.5,99.5 C 157.833,126.167 157.167,152.833 156.5,179.5C 156.333,152.165 156.5,124.831 157,97.5C 157.717,98.0442 158.217,98.7109 158.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#66c0c7",
    d: "M 95.5,114.5 C 93.901,114.232 92.5676,114.566 91.5,115.5C 61.9945,118.844 41.4945,134.177 30,161.5C 21.8895,189.045 27.0561,213.712 45.5,235.5C 17.6872,214.228 8.5205,186.561 18,152.5C 32.8749,118.811 58.7082,103.144 95.5,105.5C 95.5,108.5 95.5,111.5 95.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.376
    },
    fill: "#750d28",
    d: "M 169.5,108.5 C 168.833,136.167 168.167,163.833 167.5,191.5C 167.333,163.165 167.5,134.831 168,106.5C 168.717,107.044 169.217,107.711 169.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cac0c3",
    d: "M 91.5,115.5 C 92.5676,114.566 93.901,114.232 95.5,114.5C 95.8323,125.251 95.499,135.251 94.5,144.5C 94.5,134.833 94.5,125.167 94.5,115.5C 93.5,115.5 92.5,115.5 91.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#e61f50",
    d: "M 95.5,114.5 C 99.1667,114.5 102.833,114.5 106.5,114.5C 106.5,127.833 106.5,141.167 106.5,154.5C 90.8396,150.995 78.3396,155.661 69,168.5C 62.7167,180.852 63.2167,192.852 70.5,204.5C 68.7446,203.928 67.0779,203.094 65.5,202C 53.3132,190.703 50.1466,177.203 56,161.5C 64.7622,146.704 77.5956,141.037 94.5,144.5C 95.499,135.251 95.8323,125.251 95.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.667
    },
    fill: "#b54f61",
    d: "M 47.5,236.5 C 49.8525,237.34 51.8525,238.674 53.5,240.5C 52.8333,240.5 52.5,240.833 52.5,241.5C 50.5,240.167 48.8333,238.5 47.5,236.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.0702df20e1d28c1537bd55af4cdd9500.svg";
export { ForwardRef as ReactComponent };